import {useRef} from 'react'

import useStore from 'base/store'
import {NewRequest} from 'modules/requests'
import {Button, ListTabsPanel, Modal} from 'common/components'
import {maybePluralize} from 'common/helpers'
import {useGetUserProjects, getActiveProjects, getArchivedProjects} from '..'

export default function UserProjectsPanel() {
  const {data: projects} = useGetUserProjects()

  const activeProjects = getActiveProjects(projects)
  const archivedProjects = getArchivedProjects(projects)

  const activeProjectsCount = activeProjects?.length

  const tabs = [
    {
      key: '',
      label: maybePluralize(activeProjectsCount, 'project'),
    },
    {
      key: 'archived',
      label: maybePluralize(archivedProjects?.length, 'archived project'),
    },
  ]

  return (
    <>
      <ListTabsPanel
        path="projects"
        tabs={tabs}
        action={activeProjectsCount ? <CreateRequestButton /> : undefined}
      />
      <NewRequestModal />
    </>
  )
}

const CreateRequestButton = () => {
  const setCreateProjectOpen = useStore((state) => state.setCreateProjectOpen)

  const handleCreateProjectOpen = () => setCreateProjectOpen(true)

  return <Button onClick={handleCreateProjectOpen}>Create project</Button>
}

const NewRequestModal = () => {
  const isCreateProjectOpen = useStore((state) => state.isCreateProjectOpen)
  const setCreateProjectOpen = useStore((state) => state.setCreateProjectOpen)
  const modalWrapRef = useRef()

  const handleCreateProjectClose = () => setCreateProjectOpen(false)

  return (
    <Modal
      open={isCreateProjectOpen}
      title="New project"
      wrapProps={{ref: modalWrapRef}}
      onCancel={handleCreateProjectClose}
    >
      <NewRequest
        modalWrapRef={modalWrapRef}
        onClose={handleCreateProjectClose}
      />
    </Modal>
  )
}
